// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5533f837dbd5fa32df47","883":"c71ee633b55793b3ae7f"}[chunkId] + ".js";
};